import { render, staticRenderFns } from "./expression.vue?vue&type=template&id=3dd81eb4&scoped=true&"
import script from "./expression.vue?vue&type=script&lang=js&"
export * from "./expression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd81eb4",
  null
  
)

export default component.exports